var map = {
	"./X33-Mall_small.jpg": 921,
	"./all.svg": 922,
	"./apple-watch.png": 923,
	"./b-headphone.png": 924,
	"./coin.svg": 925,
	"./delete-btn.svg": 926,
	"./iphone-13.webp": 2363,
	"./iphone-pink.png": 927,
	"./love.svg": 928,
	"./mall-banner-cn.jpg": 929,
	"./mall-banner-id.jpg": 930,
	"./mall-banner-ms.jpg": 931,
	"./mall-banner-vn.webp": 2364,
	"./mall-banner.jpg": 932,
	"./mobile-bg.jpg": 933,
	"./price-high.svg": 934,
	"./price-low.svg": 935,
	"./shopping-cart.svg": 936,
	"./star.svg": 937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2362;